class AdpComponentCategoryController {
  constructor() {
    this.name = 'adpComponentCategory';
  }
}

export default AdpComponentCategoryController;



// WEBPACK FOOTER //
// ./src/app/components/adpComponentCategory/adpComponentCategory.controller.js